export default __webpack_public_path__ + "static/media/imag_ing_bkg.cb95d935.jpg";